"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickGameDemo = void 0;
// import { useOpenDeposit } from '@l2p/apps-shared';
// import { TransactionStatusEnum, TransactionTypeEnum } from '@l2p/pay-api';
// import {
//   useBalance,
//   useCache,
//   useIsAuthorized,
//   useTransactions,
// } from '@l2p/swr-hooks';
// import { differenceInHours } from 'date-fns';
// import * as Lockr from 'lockr';
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var react_1 = require("react");
// const GAME_DEMO_CLICKED = 'gameDemoClicked';
// const IS_DEMO_ALLOWED = 'is_demo_allowed';
// const frequencyNotification = 24;
var useClickGameDemo = function () {
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var config = (0, swr_hooks_1.useConfig)();
    var openInNewTab = config === null || config === void 0 ? void 0 : config.openGameInNewTab;
    // const { getDataFromCache, setDataToCache } = useCache();
    var router = (0, navigation_1.useRouter)();
    // const openDeposit = useOpenDeposit();
    // const [isDemoAllowed, setIsDemoAllowed] = useState(
    //   getDataFromCache(IS_DEMO_ALLOWED) || false,
    // );
    // const [hasDeposit, setHasDeposit] = useState(false);
    // const { data: transactionsData } = useTransactions(
    //   TransactionTypeEnum.Deposit,
    //   TransactionStatusEnum.Accepted,
    // );
    // const transactions = transactionsData?.transaction?.get?.edges;
    // const { data: balanceData } = useBalance();
    // const balance = parseFloat(balanceData?.amount || '0');
    // useEffect(() => {
    //   const hasSuccessDeposit = transactions?.find(
    //     (t) => t.status === TransactionStatusEnum.Accepted,
    //   );
    //
    //   if (hasSuccessDeposit) setHasDeposit(true);
    //
    //   if (balance) {
    //     if (hasSuccessDeposit && balance > 0) {
    //       setIsDemoAllowed(true);
    //     }
    //   }
    // }, [transactions?.length, balance]);
    //
    // useEffect(() => {
    //   if (isAuth) {
    //     setIsDemoAllowed(true);
    //   } else {
    //     setIsDemoAllowed(false);
    //   }
    // }, [isAuth]);
    // const onClickDemo = useCallback(
    //   (url) => {
    //     if (isDemoAllowed || !isAuth) {
    //       router.push(url);
    //       return;
    //     }
    //
    //     // no deposits -> deposit
    //     if (!hasDeposit) {
    //       openDeposit();
    //       return;
    //     }
    //
    //     const clickDate = Lockr.get(GAME_DEMO_CLICKED);
    //
    //     // has deposit and balance zero
    //     if (!clickDate && hasDeposit && balance <= 0) {
    //       Lockr.set(GAME_DEMO_CLICKED, new Date());
    //       openDeposit(`back=${url}`);
    //     }
    //
    //     if (clickDate && hasDeposit && balance <= 0) {
    //       const isClickAllowed =
    //         differenceInHours(new Date(), new Date(clickDate)) <=
    //         frequencyNotification;
    //
    //       if (!isClickAllowed) {
    //         return;
    //       } else {
    //         router.push(url);
    //       }
    //     }
    //   },
    //   [isDemoAllowed, hasDeposit, balance],
    // );
    var onClickDemo = (0, react_1.useCallback)(function (url) {
        if (openInNewTab && isAuth) {
            window.open(url, '_blank');
            return;
        }
        return router.push(url);
    }, [router, openInNewTab, isAuth]);
    return {
        isDemoAllowed: true,
        onClickDemo: onClickDemo,
    };
};
exports.useClickGameDemo = useClickGameDemo;
